import { render, staticRenderFns } from "./FormProviderTwilio.vue?vue&type=template&id=7631420a&scoped=true&"
import script from "./FormProviderTwilio.vue?vue&type=script&lang=js&"
export * from "./FormProviderTwilio.vue?vue&type=script&lang=js&"
import style0 from "./FormProviderTwilio.vue?vue&type=style&index=0&id=7631420a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7631420a",
  null
  
)

export default component.exports